module.exports = __webpack_public_path__ + "fonts/230597f.otf";